<template>
    <div>
        <div class="gap-bottom-equal  edu-about-area about-style-1  bg-lighten04"">
            <div class="container edublink-animated-shape">
                <div class="row g-5 align-items-center">
                    <div class="col-lg-6">
                        <div class="about-content">
                            <SectionTitle 
                                preTitle="香港基督徒中樂團" 
                                title='我們需要你的支持' 
                                subTitle='                                
                                    <p>本會作為非牟利基督徒音樂組織，其運作需要不少人力和金錢物質，一直以來，得到各團員出錢出力，無條件地付出。然而，我們仍需要各弟兄姊妹在禱告和奉獻上給予我們愛心的支持。</p>
                                    <p>本會已獲註冊爲慈善團體，凡奉獻滿港幣$100或以上，獻款可作扣稅之用。</p>
                                    <p>奉獻可郵寄【寄香港英皇道郵局郵政信箱35312號】</p>
                                    <p>支票抬頭寫【香港基督徒中樂團協會有限公司】</p>
                                '
                            />
                            <ul class="features-list" data-aos-delay="150" data-aos="fade-up" data-aos-duration="800">
                                <li>
                                    <a href="/files/support.pdf" download="support.pdf">
                                        <img src="/images/hkcco/formdownload.png" alt="Download PDF" width="40">
                                        <i class="fas fa-download"></i> 下載奉獻表格
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>                    
                    <div class="col-lg-6">
                        <div class="about-image-gallery">
                            <img class="main-img-1" src="/images/hkcco/prayer.webp" alt="About Image">
                            <div class="award-status bounce-slide">
                                <div class="inner">
                                    <div class="icon">
                                        <i class="icon-21"></i>
                                    </div>
                                    <div class="content">
                                        <h6 class="title"> </h6>
                                        <span class="subtitle"> </span>
                                    </div>
                                </div>
                            </div>
                            
                            <ul class="shape-group">
                                <MouseMove addClassName="shape-1" dataDepth="1" data-aos-delay="500" data-aos="fade" data-aos-duration="200" imgSrc="/images/about/shape-36.png" />
                                <MouseMove addClassName="shape-2" dataDepth="-1" data-aos-delay="500" data-aos="fade" data-aos-duration="200" imgSrc="/images/about/shape-37.png" />
                                <MouseMove addClassName="shape-3" dataDepth="1" data-aos-delay="500" data-aos="fade" data-aos-duration="200" imgSrc="/images/about/shape-02.png" />
                            </ul>
                        </div>
                    </div>
                </div>
                <ul class="shape-group">
                    <MouseMove addClassName="shape-1 circle" dataDepth="-2.3" data-aos-delay="500" data-aos="fade" data-aos-duration="200" />
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            SectionTitle: () => import('@/components/common/SectionTitle'),
            MouseMove: () => import('@/components/animation/MouseMove')
        },
        data () {
            return {
                items: [
                    {
                        src: "https://www.youtube.com"
                    }
                ],
                index: null
            }
        }
    }
</script>